const TRUE_VALUES = new Set(['1', 'true', 'yes', 'golden-flow'])

const getTutorialParams = (): URLSearchParams | null => {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search)
}

const hasTutorialFlag = (): boolean => {
  const params = getTutorialParams()
  if (!params) return false
  const tutorial = params.get('tutorial')
  const legacyTutorial = params.get('__tutorial')
  return TRUE_VALUES.has(String(tutorial || legacyTutorial || '').toLowerCase())
}

export const isTutorialModeRequested = (): boolean => hasTutorialFlag()

export const isTutorialModeEnabled = (): boolean => isTutorialModeRequested()

export const isTutorialSandboxRoute = (): boolean => {
  if (typeof window === 'undefined') return false
  const pathname = window.location.pathname
  return (
    hasTutorialFlag() &&
    (
      pathname.startsWith('/manage-books') ||
      pathname.startsWith('/book-detail/')
    )
  )
}

export const isTutorialSandboxModeEnabled = (): boolean => isTutorialSandboxRoute()

export const isTutorialUiSuppressionRequested = (): boolean => {
  const params = getTutorialParams()
  if (!params) return false
  return TRUE_VALUES.has(String(params.get('tutorial_ui_suppressed') || '').toLowerCase())
}

export const applyTutorialMode = (): (() => void) | null => null
